/// MINI MENU ///
const mini_menu = document.querySelector('.mini');
const mini_nav = document.querySelector('.mini-nav');

window.onload = function () {
  
  mini_menu.addEventListener('click', function () {
    mini_menu.classList.toggle('active');
    mini_nav.classList.toggle('active');
  });
  
};

/// Adjustments for scrolling / sticky header
window.onscroll = function() {
  const mini_menu = document.querySelector('#haul-header');
  const mini_nav = document.querySelector('.mini-nav');
  
  var scrollLimit = 50;
  if (window.scrollY >= scrollLimit) {
    mini_menu.style.cssText = 'top: 0;'
    mini_nav.style.cssText = 'top: 0;'
    
  } else {
    mini_menu.style.cssText = 'top: 50px;'
    mini_nav.style.cssText = 'top: 50px;'

  }
};
  
// /// GLEAM MODAL ///

// var modal = document.getElementById("gleam-box");
// var btn = document.getElementById("enter");
// var span = document.getElementsByClassName("close")[0];

// btn.onclick = function() {
//   modal.style.display = "block";
// }

// span.onclick = function() {
//   modal.style.display = "none";
// }

// window.onclick = function(event) {
//   if (event.target == modal) {
//     modal.style.display = "none";
//   }
// }

